import React from 'react';
import './WizardBreadCrumb.scss';

export type WizardBreadCrumbAction = {
  label: string;
  active?: boolean;
  onClick?: () => void;
};

type Props = {
  actions: WizardBreadCrumbAction[];
};
export function WizardBreadCrumb({ actions }: Props) {
  let maxActive = 0;
  actions.forEach((a, i) => {
    if (a.active) {
      maxActive = i;
    }
  });
  return (
    <div className={'container'}>
      <ul className={'breadcrumb'}>
        {actions.map((a, i) => (
          <li
            className={
              (i < maxActive ? 'finished' : '') +
              (i !== maxActive - 1 ? ' d-none d-sm-block ' : ` ${'reverse'}`) +
              (i === maxActive ? ` ${'active'}` : '') +
              (i > maxActive ? ` ${'future'}` : '')
            }
            key={a.label ?? ''}
          >
            <span
              onClick={() => {
                if (i < maxActive && a.onClick) {
                  a.onClick();
                }
              }}
            >
              {i + 1}. {a.label}
            </span>
          </li>
        ))}
        <li />
      </ul>
    </div>
  );
}
